export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';

export const forgotPasswordRequest = ({ username: mail }) => ({
    type: FORGOT_PASSWORD_REQUEST,
    payload: { mail }
});
